import React from "react";
import CaseListPage from "./CaseListPage";
import { modificationCasesConfig } from "./caseListConfig";

const IndexUserModificationCases = () => (
  <CaseListPage config={ modificationCasesConfig } />
);

export default IndexUserModificationCases;
